// import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { createTheme } from '@mui/material/styles';


const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#666669',
    },
    secondary: {
      main: '#f50057',
    },
  },
  typography:{
    fontSize: 12,
    fontFamily:[],
    // fontWeightRegular:400
  }
};
export const MuiTheme = createTheme(themeOptions);